/**
 * Query parameters a manual $pageview may carry. Everything else is dropped:
 * Clerk hands session and resume tokens around in the URL (`__clerk_db_jwt`,
 * `__clerk_ticket`, and the same again nested inside `redirect_url`), and
 * OAuth callbacks carry codes and state. An allowlist, so a new token name
 * can't leak into analytics.
 */
const PAGEVIEW_QUERY_ALLOWLIST = new Set([
  'status',
  'credits_added',
  'plan_name',
  'tab',
  'highlight',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
]);

/** origin + pathname + only the allowlisted query parameters. */
export function pageviewUrl(
  origin: string,
  pathname: string,
  searchStr: string
): string {
  const kept = new URLSearchParams();
  new URLSearchParams(searchStr).forEach((value, key) => {
    if (PAGEVIEW_QUERY_ALLOWLIST.has(key)) kept.append(key, value);
  });
  const query = kept.toString();
  return origin + pathname + (query ? `?${query}` : '');
}

/**
 * The URL with every Clerk token removed: `__clerk_*` parameters, and any
 * parameter whose value carries one (a nested `redirect_url`). Unlike
 * `pageviewUrl` it keeps the rest of the query, so autocaptured events
 * still say which search or tab they came from.
 */
export function stripClerkTokens(url: string): string {
  if (!url.includes('__clerk')) return url;
  try {
    const parsed = new URL(url);
    for (const [key, value] of Array.from(parsed.searchParams)) {
      if (key.startsWith('__clerk') || value.includes('__clerk')) {
        parsed.searchParams.delete(key);
      }
    }
    if (parsed.hash.includes('__clerk')) parsed.hash = '';
    return parsed.toString();
  } catch {
    return url.split('?')[0];
  }
}
